import { render, staticRenderFns } from "./HubUpdate.vue?vue&type=template&id=5819a73e&scoped=true"
import script from "./HubUpdate.vue?vue&type=script&lang=js"
export * from "./HubUpdate.vue?vue&type=script&lang=js"
import style0 from "./HubUpdate.vue?vue&type=style&index=0&id=5819a73e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5819a73e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5819a73e')) {
      api.createRecord('5819a73e', component.options)
    } else {
      api.reload('5819a73e', component.options)
    }
    module.hot.accept("./HubUpdate.vue?vue&type=template&id=5819a73e&scoped=true", function () {
      api.rerender('5819a73e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/HubUpdate.vue"
export default component.exports